<template>
  <div>
    <BottomSheetModal
      ref="bottomSheet"
      headerBg="#fff"
      class="glassBgNoBlure relative"
    >
      <template #header><div></div></template>
      <div
        class="w-full h-full absolute top-0 z-[-1]"
        style="backdrop-filter: blur(5px)"
      ></div>
      <div v-if="selectOption">
        <SubscriptionSelector
          :defaultOptionId="preselectedServiceOption"
          v-if="service.serviceId == 'subscription'"
          @optionSelected="
            option => {
              subscriptionSelected(option)
            }
          "
        />
        <TransactionOptionSelector
          v-else
          :defaultOptionId="preselectedServiceOption"
          :service="service"
          @noOptionFound="onNoOptionFound"
          @optionSelected="transactionOptionSelected"
        />
      </div>
      <div
        v-else-if="
          fillForm && !option.isGiftCard && service.serviceId == 'giftCard'
        "
      >
        <GiftCardSelector
          v-if="service.serviceId == 'giftCard'"
          :option="option"
          @cardSelected="
            card => {
              giftCardSelected(card)
            }
          "
        />
      </div>
      <div v-else-if="fillForm">
        <FundXBetForm
          v-if="service.serviceId == '1xbet' && option.id == 'fund'"
        />
        <WithdrawXBetForm
          v-else-if="service.serviceId == '1xbet' && option.id == 'withdraw'"
        />
        <FundOneWin v-if="service.serviceId == '1win' && option.id == 'fund'" />
        <Withdraw1WinForm
          v-else-if="service.serviceId == '1win' && option.id == 'withdraw'"
        />
        <FundBetwinnerForm
          v-else-if="service.serviceId == 'betwinner' && option.id == 'fund'"
        />
        <WithdrawBetwinnerForm
          v-else-if="
            service.serviceId == 'betwinner' && option.id == 'withdraw'
          "
        />
        <FundMelbetForm
          v-else-if="service.serviceId == 'melbet' && option.id == 'fund'"
        />
        <WithdrawMelbetForm
          v-else-if="
            service.serviceId == 'melbet' && option.id == 'withdraw'
          "
        />
        <FundEightStarzForm
          v-else-if="service.serviceId == 'eightStarz' && option.id == 'fund'"
        />
        <withdrawEightStarzForm
          v-else-if="
            service.serviceId == 'eightStarz' && option.id == 'withdraw'
          "
        />
        <BuyUsdtForm
          v-else-if="service.serviceId == 'usdt' && option.id == 'buy'"
        />
        <SellUsdtForm
          v-else-if="service.serviceId == 'usdt' && option.id == 'sell'"
        />
        <FundWalletForm
          v-else-if="service.serviceId == 'wallet' && option.id == 'fund'"
        />
        <withdrawWalletForm
          v-else-if="service.serviceId == 'wallet' && option.id == 'withdraw'"
        />
        <SellGiftCardForm
          :card="option"
          v-else-if="service.serviceId == 'giftCard' && !option.isBuying"
        />
        <BuyGiftCardForm
          :card="option"
          v-else-if="service.serviceId == 'giftCard' && option.isBuying"
        />
        <WithdrawAffiliationFrom
          v-else-if="service.serviceId == 'affiliation'"
        />
        <SubscriptionForm
          :prefilledFormData="prefilledFormData"
          v-else-if="service.serviceId == 'subscription'"
          :subscriptionOption="option"
        />
      </div>
    </BottomSheetModal>
    <TransactionLauncheListener />
    <EventListener
      uniqId="transaction_launcher_handler"
      :events="[
        'service_launching_requested',
        'service_launching_prefilled_requested',
        'launch_transaction_request',
      ]"
      @service_launching_requested="onServiceRequested"
      @service_launching_prefilled_requested="launchPreFilledService"
      @launch_transaction_request="onTransactionRequestSent"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BottomSheetModal from '@/components/utils/BottomSheetModal.vue'
import TransactionOptionSelector from './TransactionOptionSelector.vue'
import TransactionLauncheListener from './TransactionLauncheListener.vue'
import FundXBetForm from './forms/FundXBetForm.vue'
import FundBetwinnerForm from './forms/FundBetwinnerForm.vue'
import FundMelbetForm from './forms/FundMelbetForm.vue'
import FundEightStarzForm from './forms/FundEightStarzForm.vue'
import BuyUsdtForm from './forms/BuyUsdtForm.vue'
import WithdrawXBetForm from './forms/WithdrawXBetForm.vue'
import WithdrawBetwinnerForm from './forms/WithdrawBetwinnerForm.vue'
import WithdrawMelbetForm from './forms/WithdrawMelbetForm.vue'
import withdrawEightStarzForm from './forms/WithdrawEightStarzForm.vue'
import SellUsdtForm from './forms/SellUsdtForm.vue'
import EventListener from '../../utils/EventListener.vue'
import FundWalletForm from './forms/FundWalletForm.vue'
import withdrawWalletForm from './forms/WithdrawWalletForm.vue'
import GiftCardSelector from './GiftCardSelector.vue'
import SellGiftCardForm from './forms/SellGiftCardForm.vue'
import WithdrawAffiliationFrom from './forms/WithdrawAffiliationFrom.vue'
import FundOneWin from './forms/FundOneWin.vue'
import Withdraw1WinForm from './forms/Withdraw1WinForm.vue'
import BuyGiftCardForm from './forms/BuyGiftCardForm.vue'
import SubscriptionSelector from './SubscriptionSelector.vue'
import SubscriptionForm from './forms/SubscriptionForm.vue'

export default defineComponent({
  name: 'SpecificTransactionLauncher',
  components: {
    BottomSheetModal,
    TransactionOptionSelector,
    TransactionLauncheListener,
    EventListener,
    FundXBetForm,
    FundBetwinnerForm,
    FundMelbetForm,
    FundEightStarzForm,
    BuyUsdtForm,
    WithdrawXBetForm,
    WithdrawBetwinnerForm,
    WithdrawMelbetForm,
    withdrawEightStarzForm,
    SellUsdtForm,
    FundWalletForm,
    withdrawWalletForm,
    GiftCardSelector,
    SellGiftCardForm,
    BuyGiftCardForm,
    WithdrawAffiliationFrom,
    FundOneWin,
    Withdraw1WinForm,
    SubscriptionSelector,
    SubscriptionForm,
  },
  props: {},
  data() {
    return {
      preselectedServiceOption: '',
      selectOption: false,
      fillForm: false,
      service: {},
      option: {},
      prefilledFormData: null,
    }
  },
  mounted() {},
  methods: {
    async onServiceRequested(service) {
      const needRequirements = await this.askServiceRequirequirement(service)
      if (needRequirements) return

      this.preselectedServiceOption = service.option || ''
      this.service = service
      this.selectOption = true
      this.fillForm = false
      this.prefilledFormData = null
      this.$refs.bottomSheet.show()
    },
    async launchPreFilledService({ service, option, formData }) {
      console.log('service_launching_prefilled_requested')
      const needRequirements = await this.askServiceRequirequirement(service)
      if (needRequirements) return

      this.service = service
      this.option = option
      this.selectOption = false
      this.fillForm = true
      this.prefilledFormData = formData
      this.$refs.bottomSheet.show()
    },
    async askServiceRequirequirement(service) {
      if (!service?.serviceId) return true

      const requireNotification = this.checkAndRequireNotif()
      if (requireNotification) return true

      if (service.serviceId == '1xbet') {
        const accountId = await this.get1xBetAccountId()
        if (!accountId) {
          this.$Events.dispatchEvent('preference_update_requested', {
            title: this.$t('settingBettingIds.idSettingTitle', {
              bookmaker: '1xBet',
            }),
            dataToSet: 'xbetAccountId',
          })
          return true
        }
      } else if (service.serviceId == 'betwinner') {
        const accountId = await this.getBetwinnerAccountId()
        if (!accountId) {
          this.$Events.dispatchEvent('preference_update_requested', {
            title: this.$t('settingBettingIds.idSettingTitle', {
              bookmaker: 'Betwinner',
            }),
            dataToSet: 'betwinnerAccountId',
          })
          return true
        }
      }  else if (service.serviceId == 'melbet') {
        const accountId = await this.getMelbetAccountId()
        if (!accountId) {
          this.$Events.dispatchEvent('preference_update_requested', {
            title: this.$t('settingBettingIds.idSettingTitle', {
              bookmaker: 'Melbet',
            }),
            dataToSet: 'melbetAccountId',
          })
          return true
        }
      }  else if (service.serviceId == 'eightStarz') {
        const accountId = await this.getEightStarzAccountId()
        if (!accountId) {
          this.$Events.dispatchEvent('preference_update_requested', {
            title: this.$t('settingBettingIds.idSettingTitle', {
              bookmaker: 'eightStarz',
            }),
            dataToSet: 'eightStarzAccountId',
          })
          return true
        }
      } else if (service.serviceId == '1win') {
        const accountId = await this.get1WinAccountId()
        if (!accountId) {
          this.$Events.dispatchEvent('preference_update_requested', {
            title: this.$t('settingBettingIds.idSettingTitle', {
              bookmaker: '1Win',
            }),
            dataToSet: 'oneWinAccountId',
          })
          return true
        }
      }
      return false
    },
    checkAndRequireNotif() {
      const canAcceptNotification =
        this.$NotificationUtils.canAcceptNotification()
      if (!canAcceptNotification) return false
      const notificationAccepted =
        this.$NotificationUtils.notificationPermissionIsAccepted()
      if (!notificationAccepted) {
        this.$Events.dispatchEvent(
          'ask_notification_permission_to_user_required',
        )
      }
      return !notificationAccepted
    },
    async get1xBetAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const xbetAccountId = userPreferences?.xbetAccountId
      return xbetAccountId
    },
    async getBetwinnerAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const betwinnerAccountId = userPreferences?.betwinnerAccountId
      return betwinnerAccountId
    },
    async getMelbetAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const melbetAccountId = userPreferences?.melbetAccountId
      return melbetAccountId
    },
    async getEightStarzAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const eightStarzAccountId = userPreferences?.eightStarzAccountId
      return eightStarzAccountId
    },
    async get1WinAccountId() {
      const userPreferences =
        await this.$Events.sendDataRequestResolve('userPreferences')
      const oneWinAccountId = userPreferences?.oneWinAccountId
      return oneWinAccountId
    },
    onNoOptionFound() {
      this.option = {}
      this.selectOption = false
      this.fillForm = true
    },
    transactionOptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    giftCardSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    subscriptionSelected(option) {
      this.option = option
      this.selectOption = false
      this.fillForm = true
    },
    onTransactionRequestSent() {
      this.$refs.bottomSheet.hide()
    },
  },
})
</script>
